import { render, staticRenderFns } from "./TeamStatusToday.vue?vue&type=template&id=06492895"
import script from "./TeamStatusToday.vue?vue&type=script&lang=js"
export * from "./TeamStatusToday.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports